export const breadcrumb = {
  title: 'Virtual PBX',

  number: {
    index: 'PBX numbers'
  },

  media: {
    index: 'Media'
  },

  operator: {
    index: 'Operators'
  },

  group: {
    index: 'Groups',
    create: 'Add group',
    edit: 'Edit group'
  },

  contact: {
    index: 'Contacts',
    create: 'Add contact',
    edit: 'Edit contact'
  },

  'sip-account': {
    index: 'SIP accounts',
    create: 'Add SIP Account'
  },

  'service-package': {
    index: 'Service packages'
  },

  'phone-list': {
    index: 'Lists of numbers',
    create: 'Add numbers list',
    edit: 'Edit numbers list'
  },

  'time-condition': {
    index: 'Schedules',
    create: 'Add Schedule',
    edit: 'Edit schedule'
  },

  worksheet: {
    index: 'Call routing',
    create: 'Add Schema'
  },
  setting: {
    index: 'Settings PBX'
  }
};
